// extracted by mini-css-extract-plugin
export default {"collapse-typography":"mainStyle_collapse-typography__JJOiw","custom-scrollbar":"mainStyle_custom-scrollbar__cc4EK","table-header":"mainStyle_table-header__6AXKx"};